const $video = $('video:not(.ignore-controls)');
if ($video) {
  $video.click((e) => {
    const video = $(e.currentTarget);
    video.play();
  });
}

$('.video-pauseplay').click((e) => {
  const $this = $(e.currentTarget);
  const video = findVideo($this);
  if (video.length === 0) {
    return;
  }

  video[video.paused ?
    'play' :
    'pause']();

  if ($this.hasClass('fa-pause')) {
    $this.removeClass('fa-pause');
    $this.addClass('fa-play');
  } else {
    $this.removeClass('fa-play');
    $this.addClass('fa-pause');
  }
});

$('.video-repeat').click((e) => {
  const $this = $(e.currentTarget);
  const video = findVideo($this);
  if (video.length === 0) {
    return;
  }

  video.currentTime = 0;
  video.load();

  const $pausePlay = $this.siblings('.video-pauseplay');
  if ($pausePlay.length) {
    $pausePlay.removeClass('fa-play');
    $pausePlay.addClass('fa-pause');
  }
});

$('.video-mute').click((e) => {
  const $this = $(e.currentTarget);
  const video = findVideo($this);
  if (video.length === 0) {
    return;
  }

  if ($(video).prop('muted')) {
    $(video).prop('muted', false);
    $this.removeClass('fa-volume-off');
    $this.addClass('fa-volume-up');
  } else {
    $(video).prop('muted', true);
    $this.removeClass('fa-volume-up');
    $this.addClass('fa-volume-off');
  }
});

function findVideo(currentTarget) {
  const $this = $(currentTarget);
  const $videoOuter = $this.parents('.js-video-outer');
  if ($videoOuter.length !== 0) {
    const $videoElement = $videoOuter.find('video');
    if ($videoElement.length !== 0) {
      return $videoElement[0];
    }
  }

  return [];
}
